import React from 'react';

const GroundWorkPage: React.FC = () => {
  return (
    <div className="blank" style={{ display: 'grid', placeItems: 'center' }}>
      this is groundwork
    </div>
  );
};

export default GroundWorkPage;




